/**
 * @file faqInfo Data
 */

import { COMPANY_NAME_KO, COMPANY_CALL } from 'utils/Utils'
/**
 * @constant FAQ_CATEGORY_INFO 고객지원-고객센터 FAQ 카테고리 data
 * category_type 카테고리type
 * category_name 카테고리명
 * id faq_id
 * questions faq질문
 * answer faq답변
 */
export const FAQ_CATEGORY_INFO = [
    {
        category_type: 0,
        category_name: '전체',
    },
    {
        category_type: 1,
        category_name: '차량구매',
    },
    {
        category_type: 2,
        category_name: '부품',
    },
    {
        category_type: 3,
        category_name: '스테이션',
    },
    {
        category_type: 4,
        category_name: '성능',
    },
    {
        category_type: 5,
        category_name: '서비스',
    },
    {
        category_type: 6,
        category_name: '보조금',
    },
    {
        category_type: 7,
        category_name: '이용/결제',
    },
    {
        category_type: 8,
        category_name: '해지/환불',
    },
]

/**
 * @constant FAQ_INFO 고객지원-고객센터 FAQ data
 * category_type 카테고리type
 * category_name 카테고리명
 * id faq_id
 * questions faq질문
 * answer faq답변
 */
export const FAQ_INFO = [
    /* 카테고리-차량구매 */
    [
        {
            category_type: 1,
            category_name: '차량구매',
            id: 0,
            questions: '차량은 어떻게 구매하나요?',
            answer: `${COMPANY_NAME_KO} App의 "맵" 메뉴에서 가까운 대리점 위치를 확인 후 직접 방문하시거나 ${COMPANY_NAME_KO} App 더보기 상단의 "사전구매예약" 혹은 홈페이지의  "사전 구매 예약" 페이지에서 차량 구매 신청을 접수하시면 가까운 대리점에서 차량 구매에 대한 유선 안내가 진행됩니다.`,
        },
        {
            category_type: 1,
            category_name: '차량구매',
            id: 1,
            questions: '차량을 시승해 볼 수 있나요?',
            answer: `차량 시승은 고객센터(${COMPANY_CALL})를 통해 문의해주시면 확인 가능합니다.`,
        },
        {
            category_type: 1,
            category_name: '차량구매',
            id: 2,
            questions: '차량을 구매하면 바로 운행할 수 있나요?',
            answer: '차량구매와 별도로 스왑스테이션 이용(요금제) 가입을 하셔야 운행이 가능합니다. 차량 구매시 요금제도 동시에 가입 가능합니다.',
        },
        {
            category_type: 1,
            category_name: '차량구매',
            id: 3,
            questions: '판매 중인 모델은 어디서 확인할 수 있나요?',
            answer: `현재 판매 중인 모델은 ${COMPANY_NAME_KO} 홈페이지의 "사전 구매 예약" 페이지 혹은 ${COMPANY_NAME_KO} App 더보기 화면의 "사전구매예약" 버튼을 눌러 확인 가능합니다.`,
        },
        {
            category_type: 1,
            category_name: '차량구매',
            id: 4,
            questions: '배터리가 호환되는 다른 브랜드 차량이 있나요?',
            answer: '네, 고고로 네트워크를 사용하여 고고로 스마트배터리가 호환되는 브랜드는 AEON,  YAMAHA, PGO, YADEA 등이 있습니다.',
        },
        {
            category_type: 1,
            category_name: '차량구매',
            id: 5,
            questions: '보험가입시 보험료는 어떻게 되나요?',
            answer: '가입자(구매자)의 연령 및 보험가입 기간에  따라 보험료는 차이가 있으며 100cc이하 (소형 B) 기준으로 보험료가 책정됩니다.',
        },
    ],
    /* 카테고리-부품 */
    [
        {
            category_type: 2,
            category_name: '부품',
            id: 6,
            questions: '전용 악세서리가 있나요?',
            answer: '스마트스쿠터 기종별로 적용 가능한 전용 악세서리를 판매하고 있습니다.',
        },
        {
            category_type: 2,
            category_name: '부품',
            id: 7,
            questions: '커스텀 디자인 파츠는 어디서 구매하나요?',
            answer: '현재는 닷스테이션에서 커스텀 디자인 파츠를 직접 판매하지 않으며, 커버 부품만 구매하여 전문업체에 본인이 원하는 디자인의 스티커 제작을 의뢰하여야 합니다. 추후에 닷스테이션에서 직접 차량 커스텀 스티커를 제작 해드리는 서비스를 출시할 계획입니다. ',
        },
    ] /* 카테고리-스테이션 */,
    [
        {
            category_type: 3,
            category_name: '스테이션',
            id: 8,
            questions: '회사에 요청하면 스테이션을 설치 해 주나요?',
            answer: `스테이션 설치는 설치예정 장소의 적합성과 전력 조건 확인 등 선행되어야 할 부분들이 있으므로 고객센터(${COMPANY_CALL})으로 문의해주시면 확인 가능합니다.`,
        },
        {
            category_type: 3,
            category_name: '스테이션',
            id: 9,
            questions: '차량을 구매하면 배터리도 주는건가요?',
            answer: '닷스테이션의 모든 차량은 배터리 스왑 스테이션 전용 차량으로, 사용자는 닷스테이션의 스왑 스테이션에서 공유형 배터리를 교환하여 사용하게 됩니다. 배터리 성능 관리를 위해 차량 내부와 스테이션에 삽입된 배터리는 닷스테이션의 소유이며 닷스테이션은 스왑스테이션과 배터리 상태를 상시 모니터링하며 최상의 성능을 유지하고 있습니다.',
        },
        {
            category_type: 3,
            category_name: '스테이션',
            id: 10,
            questions: '차량 중고 판매 시 차량 배터리는 어떻게 하나요?',
            answer: '배터리는 닷스테이션의 자산이기 때문에 중고판매 시 배터리를 포함할 수 없고 기존 소유자는 판매 전 스왑스테이션 이용 해지를 신청하셔야 하며, 중고 차량 구매자에게 별도로 스왑스테이션(요금제) 가입 신청을 해야 한다고 안내 해 주셔야 합니다.',
        },
        {
            category_type: 3,
            category_name: '스테이션',
            id: 11,
            questions: '추가로 배터리를 구매 할 수 있나요?',
            answer: '모든 배터리는 닷스테이션의 소유이며 사용자가 배터리만 별도로 구매하실 수 없습니다. 모든 배터리는 스왑스테이션 요금제 가입 후 교체 방식으로만 사용하실 수 있습니다.',
        },
        {
            category_type: 3,
            category_name: '스테이션',
            id: 12,
            questions: '스테이션 이용시간이 정해져 있나요?',
            answer: '배터리 스왑 스테이션은 고객님의 편의를 위해 24시간 운영하고 있습니다.',
        },
        {
            category_type: 3,
            category_name: '스테이션',
            id: 13,
            questions: '스테이션 설치 현황과 계획은 어떻게 알 수 있나요?',
            answer: `설치된 스테이션의 위치는 홈페이지의 스왑네트워크 페이지 또는 ${COMPANY_NAME_KO} 어플리케이션에서 확인하실 수 있으며 홈페이지의 스왑네트워크 페이지에서 곧 설치 예정인 스테이션 위치를 확인하실 수 있습니다.`,
        },
        {
            category_type: 3,
            category_name: '스테이션',
            id: 14,
            questions: '충전시간은 얼마나 걸리나요?',
            answer: '배터리 교체 방식으로 충전을 기다리실 필요가 없으며 완충 배터리로 교체하는데 약 15초 정도 소요 됩니다.',
        },
        {
            category_type: 3,
            category_name: '스테이션',
            id: 15,
            questions: '교체한 배터리가 100% 충전이 안되어 있어요',
            answer: '배터리 스왑 스테이션은 스마트 시스템으로 상시 관리되고 있어 배터리 교체 시 해당 스테이션에서 가장 최적의 배터리가 자동으로 배출되며 배터리 교체횟수에 상관없이 암페어 사용량에 따라 요금이 부과되기 때문에 100% 충전이 안된 배터리라 하더라도 청구되는 요금에는 영향을 주지 않습니다.',
        },
        {
            category_type: 3,
            category_name: '스테이션',
            id: 16,
            questions: '가정용 개별 충전기가 있나요?',
            answer: '가정용 개별 충전기는 Gogoro사에서도 단종 예정인 제품으로, 따로 제공하거나 판매하지 않습니다.',
        },
        {
            category_type: 3,
            category_name: '스테이션',
            id: 17,
            questions: '배터리의 수명은 어떻게 되나요?',
            answer: '배터리는 최소 2,000 ~ 3,000번 까지 충전이 가능하고, 닷스테이션은 배터리 효율을 상시 모니터링하며 일정 수준 이하로 효율이 저하된 배터리는 새배터리로 교체하여 운영합니다.',
        },
    ],
    /* 카테고리-성능 */
    [
        {
            category_type: 4,
            category_name: '성능',
            id: 18,
            questions: 'GOGORO 2 UTILITY의 최대 적재량이 얼마인가요?',
            answer: '배달용으로 설계된 모델로 기본 짐대(캐리어)가 장착되어 있으며 짐대에는 최대 45kg까지 적재가 가능하며 차량은 운전자 포함 총 160kg까지 하중을 견딜 수 있습니다.',
        },
        {
            category_type: 4,
            category_name: '성능',
            id: 19,
            questions: '완충 시 주행 가능거리는 얼마인가요?',
            answer: '70km 정속 주행 시 약 65km 운행 가능하며, 30km 정속 주행 시에는 최대 170km까지 주행 가능합니다. 다만, 이 수치는 계절, 운행 습관, 환경 등에 따라 차이가 발생할 수 있습니다.',
        },
        {
            category_type: 4,
            category_name: '성능',
            id: 20,
            questions: '차량을 오래 사용하면 배터리 효율이 떨어지지 않나요?',
            answer: '닷스테이션에서 판매하는 모든 차량은 IQ 시스템이 적용되어 꾸준히 배터리 효율 관리 시스템이 원격으로 업그레이드되기 때문에 차량을 오래 사용한다고 하더라도 차량의 배터리 관리 효율은 꾸준히 향상됩니다.',
        },
        {
            category_type: 4,
            category_name: '성능',
            id: 21,
            questions: '배터리를 오래 사용하면 효율이 떨어지지 않나요?',
            answer: '닷스테이션은 배터리 효율을 상시 모니터링하고 있으며 일정 수준 이하로 효율이 저하된 배터리는 새배터리로 교체하기 때문에 고객은 항상 성능이 보장된 배터리를 사용하게 됩니다.',
        },
        {
            category_type: 4,
            category_name: '성능',
            id: 22,
            questions: '기종별 cc는 어떻게 되나요?',
            answer: '전기이륜차의 특성상 내견기관 이륜차처럼 cc로 표기되지는 않고 최대 출력으로 표기합니다. 보험료는 보험사 기준으로 100cc이하(소형 B)로 책정 되나 체감 성능은 125cc차량과 유사하거나 뛰어난 수준입니다.',
        },
        {
            category_type: 4,
            category_name: '성능',
            id: 23,
            questions: '모터의 내구성은 어떻게 되나요?',
            answer: '차량관리나 운행 조건, 운전자의 성향에 따라 상이하나 10만km 이상 운행 시에도 주행에 무리가 없을 정도로 높은 내구성을 자랑합니다. ',
        },
        {
            category_type: 4,
            category_name: '성능',
            id: 24,
            questions: '최고속도는 얼마인가요?',
            answer: '최고속도는 차량 기종에 따라 시속 100km~110km로 상이합니다. ',
        },
        {
            category_type: 4,
            category_name: '성능',
            id: 25,
            questions: '브레이크 성능은 어떤가요?',
            answer: `브레이크 성능은 차량 기종에 따라 상이하며, 고고로 2 Plus, 2 Utility 모델은 SBS 방식의 앞뒤 연동브레이크를 적용하여 안전성을 향상시켰습니다. 또한 ${COMPANY_NAME_KO} 자체모델 EV-C1과 고고로 S2 모델은 ABS를 탑재하여 뛰어난 브레이크 성능을 자랑합니다.`,
        },
        {
            category_type: 4,
            category_name: '성능',
            id: 26,
            questions:
                '고고로2 유틸리티를 타고 있는데 계기판에 배터리양이 아이콘 모양으로만 표시가 되는데 개선해 주세요.',
            answer: '현재 해당 사항은 대만 Gogoro사에 전달되어 배터리 잔량을 % 로 표시하기 위한 Gogoro사의 시스템 변경 작업이 진행 중 입니다.',
        },
        {
            category_type: 4,
            category_name: '성능',
            id: 27,
            questions: '제로백은 몇 초가 나오나요?',
            answer: '이륜차는 성능 평가에 주로 제로오십(0→50km) 기준을 적용하며, 차량 기종에 따라 상이하지만 고고로 S2 모델 기준 제로오십은 3.8초 입니다.',
        },
        {
            category_type: 4,
            category_name: '성능',
            id: 28,
            questions: '차량에 회생제동 기능이 있나요?',
            answer: '네, 모든 기종은 회생제동 기능을 지원하여 주행 가능거리를 극대화합니다 (회생제동 ON/OFF 가능)',
        },
        {
            category_type: 4,
            category_name: '성능',
            id: 29,
            questions: '차량 관리를 위한 별도의 앱이 존재하나요?',
            answer: `${COMPANY_NAME_KO} App을 사용하시면 차량 관리 및 제어, 스테이션 위치 확인, 차량 정보 확인 등 다양한 기능을 사용하실 수 있습니다.`,
        },
    ],
    /* 카테고리-서비스 */
    [
        {
            category_type: 5,
            category_name: '서비스',
            id: 30,
            questions: '소모품 교체 및 A/S 정비는 어떻게 받을 수 있나요?',
            answer: `지역별 서비스망에 방문하시면 됩니다. 주변 서비스망 위치는 ${COMPANY_NAME_KO} 홈페이지의 "고객지원" 페이지나 ${COMPANY_NAME_KO} APP의 맵을 통해 확인하실 수 있습니다.`,
        },
    ],
    /* 카테고리-보조금 */
    [
        {
            category_type: 6,
            category_name: '보조금',
            id: 31,
            questions: '전기차 구매 보조금은 어떻게 신청하나요?',
            answer: `보조금은 개인이 아닌 대리점에서 대신 신청하므로, 주변 ${COMPANY_NAME_KO} 대리점이나 ${COMPANY_NAME_KO} 고객센터(${COMPANY_CALL})로 문의바랍니다.`,
        },
        {
            category_type: 6,
            category_name: '보조금',
            id: 32,
            questions: '보조금 받고 구매해서 언제든지 중고로 판매할 수 있나요?',
            answer: '정부 보조금은 지자체의 예산으로 지급하는 것으로 의무운행 기간 2년 이후부터는 자유롭게 타 지역으로도 중고차를 판매할 수 있습니다.  단, 6개월 이후부터는 동일한 지자체 내에서 중고 판매가 가능합니다.',
        },
        {
            category_type: 6,
            category_name: '보조금',
            id: 33,
            questions: '단순히 2년동안 차량을 보유하고 있다가 2년이 지난 시점에 중고로 판매할 수 있나요?',
            answer: '2년의 의무 운행기간은 보유기간이 아닙니다. 이륜차 의무보험 가입기간 2년을 채우셔야 타 지역으로 판매가 가능합니다.',
        },
        {
            category_type: 6,
            category_name: '보조금',
            id: 34,
            questions: '의무 운행기간인 2년 이전에 부득이하게 타 지역 개인에게 중고로 판매하면 불이익이 발생하나요?',
            answer: '네, 2년의 의무운행기간 동안 월 별로 보조금 환수율이 정해져 있어 기간에 따라 해당 지자체에 보조금 일부를 환수해야 합니다.',
        },
        {
            category_type: 6,
            category_name: '보조금',
            id: 35,
            questions: '차량 구매시 취,등록세가 발생하나요?',
            answer: '네, 지자체별로 금액차이가 있으며, 전기이륜차 소형모델 기준 취,등록세가 약 9~11만원 가량 발생됩니다.',
        },
    ],
    /* 카테고리-이용/결제 */
    [
        {
            category_type: 7,
            category_name: '이용/결제',
            id: 36,
            questions: '충전 요금이 체납되면 언제 중단되나요?',
            answer: '이용 요금 연체 8일차부터는 이용자의 계정이 배터리 교체가 1회만 가능한 상태로 전환되며, 1회 스왑 후에는 더 이상 배터리 교체가 불가합니다. 배터리 교체를 하지 않더라도 연체 16일차부터는 배터리 교환이 불가한 상태로 자동 전환됩니다.',
        },
        {
            category_type: 7,
            category_name: '이용/결제',
            id: 37,
            questions: '충전 요금 연체료는 얼마나 부과되나요?',
            answer: '충전 요금제 미납에 대한 연체료 부과 규정은 아래와 같습니다.<br/>연체 1일차 - 7일차 : 연체료 없음<br/>연체 8일차 : 미납 요금의 0.6% 부과<br/>연체 16일차: 미납 요금의 1% 부과',
        },
        {
            category_type: 7,
            category_name: '이용/결제',
            id: 38,
            questions: '일시정지는 어떤 서비스인가요?',
            answer: '일시정지는 최대 15일 기간 내에서 원하는 기간동안 일시적으로 요금이 부과되지 않는 서비스입니다. 일시정지 시 일시정지한 기간만큼 요금이 일할 계산되어 자동 차감되며 제공 암페어량 또한 자동 차감됩니다. 최대 월 1회 신청 가능하며, 기존 세팅 기간이 지나면 자동으로 해제됩니다.',
        },
        {
            category_type: 7,
            category_name: '이용/결제',
            id: 39,
            questions: '일시정지는 어떻게 하나요?',
            answer: `일시정지는 고객센터(${COMPANY_CALL})을 통해 문의주시면 가능합니다.`,
        },
        {
            category_type: 7,
            category_name: '이용/결제',
            id: 40,
            questions: '요금제 변경은 어떻게 하나요?',
            answer: `요금제 변경은 고객센터(${COMPANY_CALL})를 통해 문의주시면 가능하시며, 변경 시 익월 1일부터 변경된 요금제가 적용됩니다.`,
        },
        {
            category_type: 7,
            category_name: '이용/결제',
            id: 41,
            questions: '스포츠모드 가입은 어떻게 하나요?',
            answer: `스포츠모드는 자동 선결제로 진행되는 월간 구독 시스템이며 ${COMPANY_NAME_KO} App을 통해 가입 가능합니다.`,
        },
    ],
    /* 카테고리-해지/환불 */
    [
        {
            category_type: 8,
            category_name: '해지/환불',
            id: 42,
            questions: '스포츠모드 해지는 어떻게 하나요?',
            answer: `스포츠모드 해지는 고객센터(${COMPANY_CALL})를 통해 문의주시면 가능합니다. 해지 완료 시에는 다음 결제 도래일에 결제가 일어나지 않으며, 이용 만료일까지는 계속 이용하실 수 있습니다.`,
        },
        {
            category_type: 8,
            category_name: '해지/환불',
            id: 43,
            questions: '요금제 해지는 어떻게 하나요?',
            answer: `요금제 해지는 고객센터(${COMPANY_CALL})를 통해 문의주시면 가능합니다. 해지 요청 시 사용하시는 요금제는 즉시 해지되며 당월 사용하신 요금에 대해 일할 계산 후 청구됩니다.`,
        },
        {
            category_type: 8,
            category_name: '해지/환불',
            id: 44,
            questions: '회원 탈퇴는 어떻게 하나요?',
            answer: `닷스테이션 App 로그인 후 더보기 > 회원정보 > 하단에 "회원탈퇴" 버튼을 눌러주세요. 요금제해지, 미납금 확인 후 회원탈퇴가 진행됩니다 :) 좋은 하루 되세요~!`,
        },
    ],
]
